import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../../apiClient'
import { OntologyFeature } from './ontologyFeatureTypings'

export const USE_ONTOLOGY_FEATURE_BY_ID_KEY = 'program-settings-item-ontology'

type UseGetOntologyFeatureById = {
  programId?: string
  featureId?: string
}
export function useOntologyFeatureById(params: UseGetOntologyFeatureById) {
  return useQuery({
    queryKey: [USE_ONTOLOGY_FEATURE_BY_ID_KEY, params],
    queryFn: async () => {
      const { data } = await apiClient.get<OntologyFeature>(
        `/int/v3/programs/${params.programId}/ontology/${params.featureId}`
      )

      return data
    },
    enabled: Boolean(params.programId) && Boolean(params.featureId),
    refetchOnWindowFocus: false,
  })
}
